<div class="mobile-quick-access-fab">
  @if (expanded()) {
    <div class="mobile-quick-access-fab__menu" role="menu">
      @for (item of items(); track item.Route) {
        <button
          type="button"
          class="mobile-quick-access-fab__action"
          role="menuitem"
          (click)="onAction(item)"
        >
          <span class="material-icons mobile-quick-access-fab__action-icon" aria-hidden="true">{{ item.Icon }}</span>
          <span class="mobile-quick-access-fab__action-label">{{ item.Label }}</span>
        </button>
      }
    </div>
  }

  <button
    type="button"
    class="mobile-quick-access-fab__trigger"
    [attr.aria-expanded]="expanded()"
    [attr.aria-label]="'mobile.quickAccess.open' | translate"
    (click)="toggle()"
  >
    <img
      class="mobile-quick-access-fab__flame"
      src="assets/kiraah/kiraah-favicon.svg"
      alt=""
      aria-hidden="true"
    />
    @if (expanded()) {
      <span class="material-icons mobile-quick-access-fab__close" aria-hidden="true">close</span>
    }
  </button>
</div>
